/**
 *
 * Video Player UI
 *
 * Functionality for the video page
 */

const $         = require( 'jQuery' );
const _LStorage = require( './utilities/_LStorage.js' );
const _model    = require( './utilities/_model.js' );
const attribution = require( './utilities/_attribution-workflow' );
const _Forms    = require( './utilities/_form-controller' );

var VideoUI = function(el){

    this.$el            = $(el);
    this.$videoCTA      = this.$el.find( '.itbl-c-video__player' );
    this.$revealForm    = $(document).find( '#itbl-video-form' );
    this.$form          = this.$revealForm.find( '.itbl-c-video-form__gated' );
    this.$videoTitle    = this.$el.find( '.itbl-c-video__title' );
    this.$video         = this.$el.find( '#itbl-c-product-tour__play-video' );

    //initialize Foundation plugins
    this.FormInstance       = new Foundation.Abide( this.$form );
    this.RevealInstance     = new Foundation.Reveal( this.$revealForm );

    //get all visible form input fields as array
    this.$visibleInputs     = this.$form.find( 'select,checkbox,:input:not([type="hidden"], [type=submit] )' ).map( (i, el ) => el.getAttribute( 'name') ).get();

    this.itblObj    = 'iterable';
    this.isGated    = this.$el.get(0).hasAttribute( 'data-form-gated' );
    this.canPlay    = false;

    //get the user email from localstorage
    this.userEmail      = _LStorage.decrypt__get( 'iterable/encrypted/Email' );
    this.userFirstName  = _LStorage.decrypt__get( 'iterable/encrypted/FirstName' );
    this.userLastName   = _LStorage.decrypt__get( 'iterable/encrypted/LastName' );

    this.APIState     = Object.assign(
        {},
        {
            wp_email_to         : 'forms@iterable.com',
            wp_email_subject    :  `New view of video: ${this.$videoTitle.text()}`,
            wp_email_message    : null, //we gotta build this message body
            eventName           : 'formFill',

        }
    );

    this.init();
};

VideoUI.prototype.init = function(){
    //events
    this.events();
    
};

VideoUI.prototype.events = function(){
    
    this.$form
        .on( 'submit', _Forms.event__PreventDefault )
        .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault )
        .on( 'formvalid.zf.abide', this.event__validFrom.bind(this) );


    this.$videoCTA.on( 'click', this.event__routeVideo.bind(this) );

};

VideoUI.prototype.event__validFrom = function( event, target ){

    //disable normal submit event
    event.preventDefault();

    //serialize this data into name/value
    _Forms.helper__addFormInputsToState( this.$form, this.APIState );

    for (let x in this.APIState) {
      this.APIState[x] = (this.APIState[x] || '').split('; ').pop().trim()
    }

    _Forms.helper__setAllEncryptedVals( this.$visibleInputs, this.APIState );

    _Forms.marketo__submit(this.APIState, undefined, undefined, this.$form)
        .catch( e =>{
            console.log( e );
        } )
        .finally( ()=>{

        //play the video
        this.$revealForm.foundation( 'close' );

        setTimeout( ()=>{
            this.ctrl__openFancyapp();
        }, 1000 );

        //submit Google Tag Manager event
        dataLayer.push({'event' : 'ajaxFormSubmitted', 'ajaxFormName' : $(document).find( '.itbl-c-hero__title' ).text()});

    } );

    //just to be sure
    return false;
};

VideoUI.prototype.event__routeVideo = function( event ){

    event.preventDefault();

    this.APIState.Email = _LStorage.decrypt__get( 'iterable/encrypted/Email' );

    if (!this.APIState.Email) {
      delete this.APIState.Email
    }

    if( ! this.isGated ){

        this.ctrl__openFancyapp();

        return;
    }

    if(
      this.APIState.Email &&
      _LStorage.decrypt__get('iterable/encrypted/FirstName') &&
      _LStorage.decrypt__get('iterable/encrypted/LastName') &&
      _LStorage.decrypt__get('iterable/encrypted/Company') &&
      _LStorage.decrypt__get('iterable/encrypted/Country')
    ){

        this.APIState.FirstName = _LStorage.decrypt__get('iterable/encrypted/FirstName');
        this.APIState.LastName = _LStorage.decrypt__get('iterable/encrypted/LastName');
        this.APIState.Company = _LStorage.decrypt__get('iterable/encrypted/Company');
        this.APIState.Country = _LStorage.decrypt__get('iterable/encrypted/Country');
        this.APIState.marketingConsent = JSON.stringify(_LStorage.decrypt__get('iterable/encrypted/marketingConsent'));

        //setup
        _Forms.helper__getHiddenMetadata( this.$form, this.APIState );

        this.ctrl__openFancyapp();

        for (let x in this.APIState) {
          this.APIState[x] = (this.APIState[x] || '').split('; ').pop().trim()
        }

        _Forms.marketo__submit(this.APIState, undefined, undefined, this.$form)
            .catch( e =>{
                console.log( e );
            } );


    }else{

        this.$revealForm.foundation('open');
    }


};

VideoUI.prototype.ctrl__openFancyapp    = function(){

    $.fancybox.open({
        src     :  this.$video.attr('href'), // Source of the content,
    })

};


$(document).ready(function(){
    $('.itbl-c-video').each(function(){
        new VideoUI(this);
    });

});
